import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { BFC } from '@/shared/types/react';
import { Icon, IconProps } from '@/shared/uikit/Icon';

type BtnCloseProps = Pick<IconProps, 'size'> & {
  onClick: () => void;
};

export const BtnClose: BFC<BtnCloseProps> = ({ onClick, size = 's20', ...props }) => (
  <Container onClick={onClick} {...props}>
    <Icon name="x" size={size} />
  </Container>
);

const Container = styled.button`
  display: inline-flex;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  color: ${COLORS.systemDark200};
  background: transparent;
  cursor: pointer;
  transition: background 0.2s;

  &&&:hover {
    background: rgba(15, 23, 35, 0.06);
  }
`;
